import styled from 'styled-components';
import { SketchPicker as ReactColorSketchPicker, BlockPicker as ReactColorBlockPicker } from 'react-color';

export const BlockPicker = styled(ReactColorBlockPicker)`
    margin-top: -6px;
    border-radius: 3px !important;
    margin-left: 2px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px !important;

    >div:nth-child(2) {
        display: none !important;
    }
    >div:nth-child(3)>div:nth-child(2) {
        display: none;
    }
    >div:nth-child(3)>div:nth-child(1) span>div {
        border: 1px solid #cccc !important;
    }
`;

/* stylelint-disable no-descending-specificity */
export const SketchPicker = styled(ReactColorSketchPicker)`
    >div:first-child {
        padding-bottom: 40px !important;
    }

    >div:nth-child(3) {
        line-height: normal;
    }

    >div:nth-child(3) span {
        color:${({ theme }) => `${theme.colors.neutral900} !important`};
        font-size: 10px !important;
        font-weight: 600;
    }

    >div:nth-child(3)>div:nth-child(1) span {
        text-align: left !important;
        text-transform: uppercase !important;
        letter-spacing: 1px;
    }

    >div:nth-child(4) {
        border-top: 0 !important;
    }

    &.block-btn-picker>div:nth-child(4)>div {
        width: 18px !important;
        height: 18px !important;
    }
`;

export const CustomSketchPicker = styled(SketchPicker)`
    /* create "empty" space for customization label and button */
    >div:nth-child(4) {
        margin-top: 20px !important;
        border-top: 0 !important;
    }
`;
/* stylelint-enable no-descending-specificity */

export const CustomizationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 107px;
    margin-left: 10px;
    margin-right: 10px;
    border-top: 1px solid rgb(217, 218, 219);
    padding: 6px 0;
`;

export const LabelContainer = styled.div`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
    margin: auto 0;
`;

export const ButtonContainer = styled.div`
    width: 18px;
    height: 18px;
    margin: auto 0;
    margin-right: 2px;
    line-height: 1rem;
`;

export const GearContainer = styled.div`
    width: 18px;
    height: 18px;
`;
